/**
 * Groups flat proposal data fields by (field_tag, field_index) and maps
 * snake_case keys to camelCase RecordDataField structure.
 */
export var proposalDataToRecordDataFields = function (flat) {
    var _a, _b;
    if (flat.length === 0)
        return [];
    // Group rows by (field_tag, field_index)
    var groups = new Map();
    for (var _i = 0, flat_1 = flat; _i < flat_1.length; _i++) {
        var row = flat_1[_i];
        var key = "".concat(row.field_tag, ":").concat(row.field_index);
        var existing = groups.get(key);
        if (existing) {
            existing.push(row);
        }
        else {
            groups.set(key, [row]);
        }
    }
    // Convert each group to a RecordDataField
    var result = [];
    for (var _c = 0, _d = Array.from(groups.values()); _c < _d.length; _c++) {
        var rows = _d[_c];
        var first = rows[0];
        var subfields = rows.map(function (row) {
            var components = (row.components || []).map(function (c) { return ({
                componentType: c.component_type,
                value: c.value,
            }); });
            return {
                subfieldCode: row.subfield_code || '',
                subfieldIndex: row.subfield_index,
                value: row.value,
                sourceAuthorityId: row.source_authority_id || null,
                sourceHeadingId: null,
                components: components,
            };
        });
        result.push({
            fieldTag: first.field_tag,
            fieldIndex: first.field_index,
            indicator1: (_a = first.indicator1) !== null && _a !== void 0 ? _a : null,
            indicator2: (_b = first.indicator2) !== null && _b !== void 0 ? _b : null,
            subfields: subfields,
        });
    }
    // Sort by fieldTag (string sort), then by fieldIndex
    result.sort(function (a, b) {
        var tagCmp = a.fieldTag.localeCompare(b.fieldTag);
        if (tagCmp !== 0)
            return tagCmp;
        return a.fieldIndex - b.fieldIndex;
    });
    return result;
};
